<footer class="footer">
    <div class="footer-copyright">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-xs-12">
            <div class="copy-right text-left">© 2023 Elrey Labs ®  - Estúdio Criativo e Tech</div>
          </div>
          <div class="col-md-6 col-xs-12">
            <ul class="social-media">
              <li *ngFor="let social of socialMedia">
                <a routerLink="/home-one" [ngClass]="social.icon"></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>